import { render, staticRenderFns } from "./TelephoneInput.vue?vue&type=template&id=07b71f6f"
import script from "./TelephoneInput.vue?vue&type=script&lang=js"
export * from "./TelephoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports